<template>
  <v-container class="py-8 py-md-10 py-lg-12">
    <SearchBasicForm v-if="!xsOnly" />
    <DialogSearchBasicWidget v-else />

    <LoadingWidget v-if="loading" />

    <template v-else-if="items.length">
      <div
        v-if="hasFilter"
        class="
          text-body-2 text-sm-body-1 text-center
          font-weight-regular
          px-3
          mt-3 mt-md-5
        "
      >
        Sua busca retornou
        <span class="font-weight-bold">{{ totalItems }}</span> resultado(s)
      </div>

      <v-sheet
        class="d-flex justify-end mx-auto mt-3 search-basic-form"
        max-width="1180px"
      >
        <div>
          <OrderSelect v-on:reorder="getList()" />
        </div>
      </v-sheet>

      <div class="justify-center mt-3 grid-list">
        <PropertyCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>

      <PaginationWidget
        v-if="countPages > 1"
        class="mt-8 mt-md-10"
        :count="countPages"
      />
    </template>
    <v-alert v-else class="mt-8 mt-md-10 mt-lg-12" type="info">
      Nenhum imóvel encontrado
    </v-alert>
  </v-container>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import SearchBasicForm from "../components/forms/SearchBasicForm.vue";
import DialogSearchBasicWidget from "../components/widgets/DialogSearchBasicWidget.vue";
import OrderSelect from "../components/forms/fields/OrderSelect.vue";
import PropertyCard from "../components/cards/PropertyCard.vue";
import PaginationWidget from "../components/widgets/PaginationWidget.vue";
import { getCookie } from "../utils/cookie";

const _config = {
  mod: "properties",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  loading: true,
  items: [],
  totalItems: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    query() {
      return this.$route.query;
    },
    hasFilter() {
      if (
        (this.category &&
          this.$route.path === "/rural" &&
          this.category !== "Área,Chácara,Fazenda,Sítio") ||
        this.district ||
        this.city ||
        this.reference ||
        this.garage ||
        this.bedrooms ||
        this.suites ||
        this.totalArea ||
        this.builtArea ||
        this.search ||
        this.price
      )
        return true;

      return false;
    },
    page() {
      return this.query.p;
    },
    business() {
      switch (this.$route.path) {
        case "/imoveis":
          return "Venda";
        case "/locacao":
          return "Aluguel";
        default:
          return null;
      }
    },
    category() {
      const category = this.query.tipo;

      if (category) return category;

      switch (this.$route.path) {
        case "/terrenos":
          return "Terreno,Terreno Comercial";
        case "/rural":
          return "Área,Chácara,Fazenda,Sítio";
        default:
          return "";
      }
    },
    price() {
      return this.query.preco ? this.query.preco.split(",") : null;
    },
    totalArea() {
      return this.query["area-total"]
        ? this.query["area-total"].split(",")
        : null;
    },
    builtArea() {
      return this.query["area-construida"]
        ? this.query["area-construida"].split(",")
        : null;
    },
    district() {
      return this.query.bairro;
    },
    city() {
      return this.query.cidade;
    },
    reference() {
      return this.query.referencia;
    },
    garage() {
      return this.query.garagem;
    },
    bedrooms() {
      return this.query.quartos;
    },
    suites() {
      return this.query.suites;
    },
    search() {
      return this.query.q;
    },
    countPages() {
      return Math.ceil(this.totalItems / _pagination.itemsPerPage);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = { ..._pagination };

      if (this.page) params.page = this.page;
      if (this.business) params.business = this.business;
      if (this.category) params.category = this.category;
      if (this.district) params.district = this.district;
      if (this.city) params.city = this.city;
      if (this.reference) params.reference = this.reference;
      if (this.garage) params.garage = this.garage;
      if (this.bedrooms) params.bedrooms = this.bedrooms;
      if (this.suites) params.suites = this.suites;
      if (this.totalArea) params.landArea = this.totalArea;
      if (this.builtArea) params.builtArea = this.builtArea;
      if (this.search) params.search = this.search;

      params.order = this.getCookie("ordenar");

      if (this.price) {
        params.minPrice = this.price[0];
        params.maxPrice = this.price[1];
      }

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (data?.list?.length) {
              this.items = data.list;
              this.totalItems = data.totalItems;
            } else this.items = data;
          },
        })
        .finally(() => (this.loading = false));
    },
    getCookie,
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    LoadingWidget,
    SearchBasicForm,
    DialogSearchBasicWidget,
    OrderSelect,
    PropertyCard,
    PaginationWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 20px 12px;
  grid-template-columns: repeat(auto-fit, 300px);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(2, calc(50% - 6px));
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
